import { render, staticRenderFns } from "./editOrderPerson.vue?vue&type=template&id=5ac79d08"
import script from "./editOrderPerson.vue?vue&type=script&lang=js"
export * from "./editOrderPerson.vue?vue&type=script&lang=js"
import style0 from "./editOrderPerson.vue?vue&type=style&index=0&id=5ac79d08&prod&lang=scss"
import style1 from "./editOrderPerson.vue?vue&type=style&index=1&id=5ac79d08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports